var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", xl: "7" } },
                [_c("app-accounting-default")],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", xl: "5" } },
                [_c("app-accounting-bookyear"), _c("app-default-central")],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [_c("w-col", [_c("app-accounting-closed-period")], 1)],
            1
          ),
          _vm.isDevMode
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", xl: "7" } },
                    [
                      _c("app-custom-report-button-list", {
                        attrs: {
                          "browse-name": _vm.$ct("accounting"),
                          "config-key": "Bookkeeping",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }